import styled from 'styled-components';

import { color } from 'theme/selectors';

export const ContactUsLink = styled.a<{ mb?: string | number }>`
    margin-bottom: ${({ mb = 0 }) => mb}px;
    border-radius: 0;
    border: 1px solid ${color('border-default')};
    letter-spacing: 2px;
    padding: 20px;
    min-height: 64px;
    display: block;
`;
